import { Modal, Button, Tooltip } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import FlowPreview from "./FlowPreview";

const FlowPreviewModal = ({ open, flow, onClose }) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    width={460}
    centered
    title={
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span>Preview — {flow?.name}</span>
        {flow?.metaFlowId && (
          <Tooltip title="Open Meta's official preview in browser">
            <Button
              size="small"
              icon={<ExportOutlined />}
              onClick={async () => {
                const { default: api } = await import("../../../../../core/axios/axiosInstance");
                try {
                  const { data } = await api.get(`/api/meta-flows/${flow._id}/preview`);
                  if (data.previewUrl) window.open(data.previewUrl, "_blank");
                } catch { /* ignore */ }
              }}
            >
              Open on Meta
            </Button>
          </Tooltip>
        )}
      </div>
    }
    styles={{ body: { padding: "16px 0 8px" } }}
  >
    <FlowPreview flow={flow} height={540} />
  </Modal>
);

export default FlowPreviewModal;
